export { default } from './PaymentMethods';
